export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "กรุณากรอกข้อความของคุณที่นี่",
      conversationalPlaceholder: "กรุณากรอกคำตอบของคุณที่นี่",
      conversationClosed: "การสนทนาสิ้นสุดแล้ว",
      conversationalDisclaimer: "คำถามติดตามจะถูกสร้างโดย AI ตามคำตอบของคุณ"
    },
    openText: {
      openEndPlaceholder: "กรุณากรอกข้อความของคุณที่นี่"
    },
    multiText: {
      fieldPlaceholder: 'คำตอบ {number}',
      instruction: 'พิมพ์คำตอบอย่างน้อย {count} คำตอบด้านล่าง ช่องละหนึ่งคำตอบ',
      instructionWithoutMinimum: 'พิมพ์คำตอบของคุณด้านล่าง ช่องละหนึ่งคำตอบ',
      minimumEntries: 'โปรดกรอกอย่างน้อย {count} คำตอบก่อนดำเนินการต่อ',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'แบรนด์ {number}',
        minimumEntries: 'โปรดกรอกอย่างน้อย {count} แบรนด์ก่อนดำเนินการต่อ'
      }
    },
    multiselect: {
      caption: "เลือกทุกตัวเลือกที่เกี่ยวข้อง"
    },
    rankOrder: {
      enterRankOrder: "กรอกลำดับ",
      placeholder: "ลากตัวเลือกของคุณมาที่นี่เพื่อจัดลำดับ"
    },
    openNumeric: {
      label: "ตัวเลขแบบเปิด"
    },
    complete: {
      message: "ขอบคุณสำหรับการทำแบบสำรวจนี้ให้เสร็จสิ้น"
    },
    openVideo: {
      warning: "กรุณาบันทึกวิดีโอก่อนดำเนินการต่อ",
      uploadStatusUploading: "โปรดรอจนกว่าเราจะประมวลผลวิดีโอของคุณให้เสร็จก่อนดำเนินการต่อ...",
      uploadStatusSuccess: "อัปโหลดสำเร็จแล้ว คุณสามารถดำเนินการต่อได้",
      uploadStatusError: "การอัปโหลดไม่เสร็จสิ้น โปรดลองอีกครั้ง"
    }
  },
  errors: {
    node: {
      text_invalid_email: 'กรุณากรอกอีเมลที่ถูกต้อง',
      text_invalid_phone: 'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง',
      text_invalid_us_zip: 'กรุณากรอกรหัสไปรษณีย์สหรัฐอเมริกา (ZIP) ที่ถูกต้อง',
      text_invalid_ca_postal: 'กรุณากรอกรหัสไปรษณีย์แคนาดาที่ถูกต้อง',
      text_invalid_uk_postal: 'กรุณากรอกรหัสไปรษณีย์สหราชอาณาจักรที่ถูกต้อง',
      text_invalid_custom: 'กรุณากรอก {fieldName} ที่ถูกต้อง',
      text_min_chars: 'กรุณากรอกอย่างน้อย {min} ตัวอักษร',
      text_max_chars: 'กรุณากรอกไม่เกิน {max} ตัวอักษร',
      text_alpha_not_allowed: 'อนุญาตเฉพาะตัวเลขเท่านั้น',
      text_numeric_not_allowed: 'อนุญาตเฉพาะตัวอักษรเท่านั้น'
    },
    external: {
      invalid: 'คำตอบสำหรับคำถามนี้ไม่ถูกต้อง',
      required: 'จะต้องตอบคำถาม',
      singlechoice_required: 'โปรดเลือกหนึ่งตัวเลือกก่อนดำเนินการต่อ',
      numeric_required: 'โปรดเลือกการให้คะแนนก่อนดำเนินการต่อ',
      text_required: 'โปรดป้อนคำตอบก่อนดำเนินการต่อ',
      bigtext_required: 'โปรดป้อนคำตอบก่อนดำเนินการต่อ',
      singlechoiceother_incomplete: 'โปรดป้อนคำตอบก่อนดำเนินการต่อ',
      multiselectother_incomplete: 'โปรดป้อนคำตอบก่อนดำเนินการต่อ',
      numeric_invalid: 'โปรดป้อนตัวเลขที่ถูกต้องก่อนดำเนินการต่อ',
      radiogrid_required: 'โปรดเลือกหนึ่งตัวเลือกสำหรับแต่ละแวก่อนดำเนินการต่อ',
      incomplete: 'กรุณาตอบคำถามนี้ให้ครบถ้วนก่อนดำเนินการต่อ',
      multiselect_min: 'โปรดเลือกอย่างน้อย {value} ตัวเลือกก่อนดำเนินการต่อ',
      multiselect_max: 'โปรดเลือกไม่เกิน {value} ตัวเลือกก่อนดำเนินการต่อ',
      multiselectother_min: 'โปรดเลือกอย่างน้อย {value} ตัวเลือกก่อนดำเนินการต่อ',
      multiselectother_max: 'โปรดเลือกไม่เกิน {value} ตัวเลือกก่อนดำเนินการต่อ',
      multiselectgrid_min: 'โปรดเลือกอย่างน้อย {value} ตัวเลือกสำหรับแต่ละแถวก่อนดำเนินการต่อ',
      multiselectgrid_max: 'โปรดเลือกไม่เกิน {value} ตัวเลือกสำหรับแต่ละแถวก่อนดำเนินการต่อ',
      rankorder_min: 'โปรดจัดอันดับอย่างน้อย {value} รายการก่อนดำเนินการต่อ',
      rankorder_max: 'โปรดจัดอันดับไม่เกิน {value} รายการก่อนดำเนินการต่อ'
    }
  }
}
